import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_CancelAssignment(
  selectedItems: any[],
  waitFor: boolean,
  setShowCancelAssignmentDialog: (showCancelAssignmentDialog: boolean) => void,
) {
  const languageStrings = React.useContext(LanguageContext);

  const [menuItem_CancelAssignment, setMenuItem_CancelAssignment] = React.useState<IContextualMenuItem>();

  const opdrachtDocSetContentTypeId = "0x0120D520006AAF2894D132DC4490C0776F6D6D2CA40035E1CF0A0F777246BCE4531413CFCF86";

  React.useEffect(() => {   
    if (selectedItems?.length === 1 && selectedItems[0].ContentTypeId == opdrachtDocSetContentTypeId) {
      setMenuItem_CancelAssignment(
          {
            key: "cancelOpdracht",
            disabled: waitFor === true,
            text: `${languageStrings.CancelAssignment}`,
            iconProps: { iconName: "Cancel" },
            onClick: () => {
              setShowCancelAssignmentDialog(true);
            }
          }
        )
    } else {
      setMenuItem_CancelAssignment(null);
    }
  }, [selectedItems, waitFor]);

  return {
    menuItem_CancelAssignment
  }

}